import { render, staticRenderFns } from "./MenuAccesos.vue?vue&type=template&id=29837dec"
import script from "./MenuAccesos.vue?vue&type=script&lang=js"
export * from "./MenuAccesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports